import React from 'react';
import Translation from '../../../../Shared/components/Translation';
import FormatUtility from '../../../../Shared/Utility/FormatUtility';
import { ZdsDivider } from '@zig-design-system/ui-components-react';
const isNotEmpty = (specification) => !specification.value || (Array.isArray(specification.value) && specification.value.length == 0);
const SpecificationList = ({ title, specifications, bottomDivider = true }) => {
    if (specifications.every((specification) => isNotEmpty(specification))) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("h2", { className: "zds-headline-md zds-margin-bottom-2" },
            React.createElement(Translation, { item: title })),
        React.createElement(React.Fragment, null, specifications.map((specification, index) => {
            if (isNotEmpty(specification)) {
                return null;
            }
            return (React.createElement("div", { className: "real-estate__property-group", key: index },
                React.createElement("dl", null,
                    React.createElement("dt", null,
                        React.createElement(Translation, { item: specification.key })),
                    React.createElement("dd", null,
                        FormatUtility.format(specification.value, specification.format),
                        ' ',
                        specification.suffix))));
        })),
        bottomDivider && React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" })));
};
export default SpecificationList;
